import Link from "next/link";
import PlayIcon from "@/components/icons/play";

// todo: nested <a> tag problem
const PlayButton = ({ slug }: { slug: string }) => {
  return (
    <Link
      className="flex items-center justify-center bg-black/40 hover:bg-black/60 hover:cursor-pointer size-12 rounded-full top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 absolute"
      href={slug}
      suppressHydrationWarning={true}
    >
      <PlayIcon
        className="size-6 text-brand-blue-600"
        fill="white"
        stroke="white"
      />
    </Link>
  );
};

export default PlayButton;
